export default __webpack_public_path__ + "static/media/file-submission-upload.ca80de3a.svg";